import { CircularProgress, Grid, Paper, Typography } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import { MouseEventHandler } from "react";
import { useParticipantActivity } from "../../hooks";
import { Button } from "../button";
import SimpleCalendar, {
  DayConfig,
} from "../simple-calendar/simple-calendar.component";
import { useStyles } from "./monthly-activity.styles";

type MonthlyActivityProps = {
  activityDates: Date[];
  onKeepLearningClicked: MouseEventHandler<HTMLButtonElement>;
};

export const MonthlyActivity = ({
  activityDates,
  onKeepLearningClicked,
}: MonthlyActivityProps) => {
  const classes = useStyles();

  const {
    data: monthlyActivityData,
    isFetching,
    selectedMonth,
    setSelectedMonth,
  } = useParticipantActivity();

  const handleMonthSelectedChanged = (newDate: Date) => {
    setSelectedMonth(newDate);
  };

  const datesToUse = monthlyActivityData || activityDates;
  const selectedDates: DayConfig[] = datesToUse.map((strDate, index) => ({
    date: new Date(strDate),
    customCssClass: index % 2 === 0 ? "even" : "odd",
  }));

  return (
    <Paper className={classes.paper} variant="outlined">
      <Grid container alignContent="center" justifyContent="center">
        <Grid container item alignContent="center" justifyContent="center">
          <Typography className={classes.title} data-testid="title">
            Monthly activity
          </Typography>
        </Grid>
        <Grid
          container
          className={classes.container}
          item
          direction="row"
          alignContent="center"
          alignItems="center"
          justifyContent="center"
          wrap="nowrap"
          xs={12}
          spacing={2}
        >
          {isFetching ? (
            <CircularProgress />
          ) : (
            <SimpleCalendar
              readonly
              allowPastDates
              initialMonth={selectedMonth}
              selectedDates={selectedDates}
              onMonthSelectedChanged={handleMonthSelectedChanged}
            />
          )}
        </Grid>
        <Button
          variant="outlined"
          className={classes.button}
          endIcon={<ChevronRight />}
          data-testid="button"
          onClick={onKeepLearningClicked}
        >
          Keep learning
        </Button>
      </Grid>
    </Paper>
  );
};
